import React from 'react';
import { Icon, Text, Tooltip } from '@upsales/components';
import { renderToString } from 'react-dom/server';
import T from 'Components/Helpers/translate';
import { useMetadata } from 'App/components/hooks/appHooks';

export function ProductDescriptionTooltip({ className, description }: { className?: string; description: string }) {
	const metadata = useMetadata();

	const prefixTooltipContent = (content: string) => {
		const TooltipContent = () => (
			<Text color="white">
				<b>{T('default.productDescription')}: </b>
				{content}
			</Text>
		);

		return renderToString(<TooltipContent />) // look at dis
			.replace(' data-reactroot=""', '')
			.replace(/<!-- -->/g, '');
	};

	const descriptionActive = metadata?.standardFields?.Product?.Description?.active ?? false;

	if (!description || !descriptionActive) return null;

	return (
		<Tooltip className={className} title={prefixTooltipContent(description)} position="top">
			<Icon name="info-circle" />
		</Tooltip>
	);
}
